export default __webpack_public_path__ + "static/media/logo_beautylandplasticsurgery.f08cd826.png";